<template>
  <div>
    <v-layout wrap class="pa-4">
      <v-flex xs12 sm6>
        <img
          src="/static/img/assets/nongtungjai_logo-form.png"
          alt
          class="responsive-img"
          style="width: 150px; height: auto"
        />
      </v-flex>
      <v-flex xs12 sm6 style="display: flex" align-center>
        <v-layout justify-end>
          <div style="font-size: 13px">
            <div>ศูนย์ปรึกษาเพื่อการเลิกสุราและการเสพติด (1413สายด่วนเลิกเหล้า)</div>
            <div>อาคารจุฬาพัฒน์14 ภาควิชาจิตเวชศาสตร์คณะแพทยศาสตร์</div>
            <div>จุฬาลงกรณ์มหาวิทยาลัย แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330</div>
          </div>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="pt-5 form-body">
        <div>แบบสำหรับส่งผู้ดื่มเข้ารับการประเมิน และตรวจรักษาในระบบบริการสุขภาพ</div>
        <div>
          <v-layout>
            <div style="width: 40px">เลขที่</div>
            <div>{{ localData.id }}</div>
          </v-layout>
        </div>
        <div>
          <v-layout>
            <div style="width: 40px">จาก</div>
            <div>ศูนย์ปรึกษาเพื่อการเลิกสุราและการเสพติด (1413 สายด่วนเลิกเหล้า)</div>
          </v-layout>
        </div>
        <div>
          <v-layout>
            <div style="width: 40px">ถึง</div>
            <div>สถานพยาบาลที่ผู้ดื่มมีสิทธิการรักษา หรือ สถานพยาบาลอื่นที่อาจเกี่ยวข้อง</div>
          </v-layout>
        </div>
        <div>
          <v-layout align-center>
            <div style="width: 40px">เรื่อง</div>
            <div>ขอส่ง</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{ localData.drinker_name }}</template>
              <input v-else v-model="localData.drinker_name" type="text" class="ma-0" />
            </div>
            <div>เข้ารับการประเมิน และตรวจรักษา</div>
          </v-layout>
        </div>
        <div class="pt-3">
          <v-layout justify-end>
            <div :class="readOnly ? '' : 'pt-2'">วันที่ออกใบส่งตัว</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{
                handleGetDateFormatted(localData.is_fill_date)
              }}</template>
              <template v-else>
                <DatepickerCustomDialog
                  v-model="localData.is_fill_date"
                  :allowed-dates="allowedDates"
                >
                  <input
                    type="text"
                    :value="handleGetDateFormatted(localData.is_fill_date)"
                    placeholder="เลือกวันที่เริ่มต้น"
                    readonly
                  />
                </DatepickerCustomDialog>
              </template>
            </div>
          </v-layout>
        </div>
        <div>
          <v-layout align-center>
            <div>ทางศูนย์ปรึกษาปัญหาสุรา 1413 (สายด่วนเลิกเหล้า) ขอส่งตัวผู้ดื่ม</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{ localData.drinker_name }}</template>
              <template v-else>
                <input v-model="localData.drinker_name" type="text" class="ma-0" />
              </template>
            </div>
          </v-layout>
        </div>
        <div>
          <v-layout align-center>
            <div>เพศ</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{ gender }}</template>
              <template v-else>
                <multiselect
                  v-model="localData.drinker_gender"
                  :options="genderOptions"
                  select-label
                  selected-label
                  label="label"
                  track-by="value"
                ></multiselect>
              </template>
            </div>
            <div>อายุ</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{ localData.drinker_age }}</template>
              <template v-else>
                <input
                  v-model="localData.drinker_age"
                  type="text"
                  style="width: 60px"
                  class="ma-0"
                />
              </template>
            </div>
            <div>ปี ซึ่งได้ทำการประเมินระดับความรุนแรง ของความ</div>
          </v-layout>
        </div>
        <div>
          <v-layout align-center>
            <div>เสี่ยงของพฤติกรรมการดื่มตามแบบประเมิน ASSIST พบว่า ผู้ดื่มได้คะแนน</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{ localData.score || '-' }}</template>
              <template v-else>
                <input
                  v-model="localData.score"
                  readonly
                  type="text"
                  style="width: 100px"
                  class="ma-0"
                />
              </template>
            </div>
            <div>ซึ่งหมายถึงมีความเสี่ยง</div>
          </v-layout>
        </div>
        <div>
          <v-layout align-center>
            <div>อยู่ในระดับ</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{ risk }}</template>
              <template v-else>
                <input :value="risk" readonly type="text" style="width: 200px" class="ma-0" />
                <input v-model="localData.risk" type="text" style="display: none" class="ma-0" />
              </template>
            </div>
            <div>และตอนนี้ผู้ดื่มมีแรงจูงใจ ของการเปลี่ยนแปลงอยู่ในระดับ</div>
            <div class="form-control px-2">
              <template v-if="readOnly">{{ manualRisk }}</template>
              <template v-else>
                <multiselect
                  v-model="localData.motivation_behavior_change"
                  :options="changeLevelOptions"
                  select-label
                  selected-label
                  label="label"
                  track-by="value"
                  placeholder="เลือกระดับ"
                ></multiselect>
              </template>
            </div>
          </v-layout>
        </div>

        <div class="pt-5">
          <div>
            <v-layout align-center>
              <div>พบว่า</div>
              <div class="form-control px-2">
                <template v-if="readOnly">{{ localData.drinker_name }}</template>
                <template v-else>
                  <input v-model="localData.drinker_name" type="text" class="ma-0" />
                </template>
              </div>
              <div>รายนี้</div>
            </v-layout>
          </div>
          <div>
            <v-layout align-center>
              <div>
                <v-checkbox
                  :readonly="readOnly"
                  :input-value="localData.is_stop_drink_in_one_year === true"
                  color="primary"
                  hide-details
                  class="mt-0"
                  @change="
                    (value) => {
                      if (value) {
                        localData.is_stop_drink_in_one_year = true
                      } else {
                        localData.is_stop_drink_in_one_year = null
                      }
                    }
                  "
                ></v-checkbox>
              </div>
              <div>เคย มีประวัติการหยุดดื่มในช่วง 1 ปีที่ผ่านมา</div>
            </v-layout>
          </div>
          <div class="pl-3">
            <v-layout align-center>
              <div>และอยู่ในกลุ่มที่</div>
              <div class="px-3">
                <v-layout align-center>
                  <div>
                    <v-checkbox
                      v-model="localData.low_risk_group"
                      :readonly="readOnly"
                      color="primary"
                      hide-details
                      class="mt-0"
                      :disabled="
                        localData.is_stop_drink_in_one_year !== true ||
                        localData.high_risk_group === true
                      "
                    ></v-checkbox>
                  </div>
                  <div>เสี่ยงน้อยที่จะเกิดอาการถอนรุนแรง</div>
                </v-layout>
              </div>
              <div>
                <v-layout align-center>
                  <div>
                    <v-checkbox
                      v-model="localData.high_risk_group"
                      :readonly="readOnly"
                      color="primary"
                      hide-details
                      class="mt-0"
                      :disabled="
                        localData.is_stop_drink_in_one_year !== true ||
                        localData.low_risk_group === true
                      "
                    ></v-checkbox>
                  </div>
                  <div>เสี่ยงมากที่จะเกิดอาการถอนรุนแรง</div>
                </v-layout>
              </div>
            </v-layout>
          </div>

          <div>
            <v-layout align-center>
              <div>
                <v-checkbox
                  :readonly="readOnly"
                  color="primary"
                  hide-details
                  class="mt-0"
                  :input-value="localData.is_stop_drink_in_one_year === false"
                  @change="
                    (value) => {
                      if (value) {
                        localData.is_stop_drink_in_one_year = false
                        localData.low_risk_group = false
                        localData.high_risk_group = false
                      } else {
                        localData.is_stop_drink_in_one_year = null
                      }
                    }
                  "
                ></v-checkbox>
              </div>
              <div>ยังไม่เคย มีประวัติการหยุดดื่มในช่วง 1 ปีที่ผ่านมา</div>
            </v-layout>
          </div>
          <div>
            ผลการประเมินความต้องการในการส่งตัวเพื่อเข้ารับบริการ ปรากฎอยู่ในตารางหน้าถัดไป
            ทั้งนี้บุคลากรในสถานพยาบาลที่รับผู้ดื่มดูแลต่อ สามารถศึกษาแนวทางการดูแลผู้ดื่มรายนี้
            ได้จากเนื้อหาที่ปรากฏอยู่ในเอกสารนี้
            หรือสามารถเข้าเยี่ยมชมเนื้อหาที่น่าสนใจเพิ่มเติมได้จาก website ……..
          </div>
        </div>

        <div class="pt-5">
          <v-layout wrap>
            <v-flex xs12>
              <div>
                <v-layout align-center>
                  <div style="width: 64px">ผู้ให้ข้อมูล</div>
                  <div class="form-control px-2">
                    <div v-if="readOnly" style="min-width: 200px; text-align: center">
                      {{ localData.drinker_name }}
                    </div>
                    <template v-else>
                      <input v-model="localData.drinker_name" type="text" class="ma-0" />
                    </template>
                  </div>
                  <div>ผู้ดื่ม</div>
                </v-layout>
              </div>
              <div>
                <v-layout align-center>
                  <div style="width: 64px">&nbsp;</div>
                  <div class="form-control px-2 pt-2">
                    <div v-if="readOnly" style="min-width: 200px; text-align: center">
                      {{ localData.filler_name }}
                    </div>
                    <template v-else>
                      <input v-model="localData.filler_name" type="text" class="ma-0" />
                    </template>
                  </div>
                  <div class="pt-2">
                    <v-layout align-center>
                      <div>เกี่ยวข้องเป็น</div>
                      <div class="form-control px-2">
                        <template v-if="readOnly">{{ localData.filler_relation }}</template>
                        <template v-else>
                          <input v-model="localData.filler_relation" type="text" class="ma-0" />
                        </template>
                      </div>
                    </v-layout>
                  </div>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div class="pt-5">
          <v-layout align-center justify-end>
            <div>เจ้าหน้าที่ 1413 ผู้ประเมิน</div>
            <div class="form-control px-2">
              <div v-if="readOnly" style="min-width: 200px; text-align: center">
                {{ localData.assessor_name }}
              </div>
              <template v-else>
                <input v-model="localData.assessor_name" type="text" class="ma-0" />
              </template>
            </div>
          </v-layout>
        </div>
        <div v-if="!readOnly" class="pt-5">
          <v-layout align-center justify-end>
            <v-btn depressed color="primary" @click="handleSaveForm">ถัดไป</v-btn>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import dayjs from 'dayjs'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import { DATETIME } from '@/constants/datetime.js'

export default {
  components: {
    Multiselect,
    DatepickerCustomDialog
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rawData: null,
      localData: {
        id: '',
        drinker_name: '',
        is_fill_date: '',
        drinker_gender: '',
        drinker_age: '',
        score: '',
        risk: '',
        motivation_behavior_change: '',
        is_stop_drink_in_one_year: false,
        low_risk_group: null,
        high_risk_group: null,
        filler_name: '',
        filler_relation: '',
        assessor_name: ''
      },
      riskLevelOptions: [
        {
          label: 'ความเสี่ยงต่ำ',
          value: 'low'
        },
        {
          label: 'ความเสี่ยงปานกลาง',
          value: 'medium'
        },
        {
          label: 'ความเสี่ยงสูง',
          value: 'high'
        }
      ],
      changeLevelOptions: [
        {
          label: 'ลังเลใจ',
          value: 'low'
        },
        {
          label: 'ตั้งใจ',
          value: 'medium'
        },
        {
          label: 'กลับไปดื่มซ้ำ',
          value: 'high'
        }
      ],
      genderOptions: [
        {
          label: 'ชาย',
          value: 'male'
        },
        {
          label: 'หญิง',
          value: 'female'
        }
      ]
    }
  },
  computed: {
    gender() {
      const tempGender = this.data.drinker_gender
        ? this.genderOptions.find((item) => item.value === this.data.drinker_gender)
        : null
      return tempGender ? tempGender.label : '-'
    },
    risk() {
      const tempRisk = this.data.risk
        ? this.riskLevelOptions.find((item) => item.value === this.data.risk)
        : null
      return tempRisk ? tempRisk.label : '-'
    },
    manualRisk() {
      const tempRisk = this.data.motivation_behavior_change
        ? this.changeLevelOptions.find(
            (item) => item.value === this.data.motivation_behavior_change
          )
        : null
      return tempRisk ? tempRisk.label : '-'
    }
  },
  watch: {
    data: {
      handler() {
        this.handleInit()
      },
      deep: true
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      this.localData.id = this.data.id
      this.localData.drinker_name = this.data.drinker_name
      this.localData.drinker_age = this.getAge(this.data.drinker_year)
      this.localData.is_fill_date = this.data.is_fill_date
        ? dayjs(this.data.is_fill_date).format(DATETIME.DATE_FORMAT)
        : dayjs().format(DATETIME.DATE_FORMAT)
      this.localData.drinker_gender = this.data.drinker_gender
        ? this.genderOptions.find((item) => item.value === this.data.drinker_gender)
        : ''
      this.localData.score = this.data.score
      this.localData.risk = this.data.risk
        ? this.riskLevelOptions.find((item) => item.value === this.data.risk)
        : ''
      this.localData.motivation_behavior_change = this.data.motivation_behavior_change
        ? this.changeLevelOptions.find(
            (item) => item.value === this.data.motivation_behavior_change
          )
        : ''
      this.localData.is_stop_drink_in_one_year = this.data.is_stop_drink_in_one_year
      this.localData.low_risk_group = this.data.low_risk_group
      this.localData.high_risk_group = this.data.high_risk_group
      this.localData.filler_name = this.data.filler_name
      this.localData.filler_relation = this.data.filler_relation
      this.localData.assessor_name = this.data.assessor_name
    },
    handleSaveForm() {
      const { drinker_gender, drinker_age, risk, motivation_behavior_change, ...rest } =
        this.localData

      const tempData = {
        drinker_gender: drinker_gender.value || '',
        drinker_year: this.getAge(drinker_age),
        risk: risk.value || '',
        motivation_behavior_change:
          motivation_behavior_change && motivation_behavior_change.value
            ? motivation_behavior_change.value
            : null,
        ...rest
      }

      this.$emit('onSaveForm', tempData)
    },
    handleGetDateFormatted(value) {
      return value ? dayjs(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    allowedDates(val) {
      return dayjs().diff(val, 'hour', true) > 0
    },
    getAge(value) {
      const currentYear = new Date().getFullYear()
      const thaiYear = currentYear + 543
      const age = thaiYear - parseInt(value)
      return value ? age : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.form-body {
  font-size: 1rem;
  line-height: 2.1rem;

  input[type='text'] {
    height: 40px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/NongTungJai/SelfReferral/Form/Page1.vue